import { ClearIcon } from "@mui/x-date-pickers-pro";
import {
  DeleteIcon,
  GKButton,
  GKModal,
  GKTextField,
  Grid2,
  IconButton,
  PlusIcon,
  SearchIcon,
  Typography,
} from "components";
import { useState } from "react";
import { Controller, useFieldArray, useFormContext } from "react-hook-form";
import { GKModalProps } from "utils/commonInterface";
import { ThemeContainer } from "utils/Theme";

const PhoneNumberModal = (props: GKModalProps) => {
  const { open, setOpen } = props;

  const form = useFormContext();

  const { theme } = ThemeContainer();

  const [searchQuery, setSearchQuery] = useState("");

  const { fields, append, remove } = useFieldArray({
    name: "couponUsage",
    control: form.control,
  });

  const filteredFields = fields.filter((field: any) =>
    field.phone.includes(searchQuery),
  );

  return (
    <GKModal
      open={open}
      setOpen={setOpen}
      width={"340px"}
      modalTitle="Add Phone Number"
      subTitle={
        <Typography fontSize={12} fontWeight={500} color="var(--neutral-500)">
          {fields.length} Added
        </Typography>
      }
      footer={
        <Grid2
          size={12}
          display={"flex"}
          justifyContent={"space-between"}
          gap={1}
        >
          <GKButton
            variant="outlined"
            color="dark"
            fullWidth
            onClick={() => append({ phone: "" })}
            startIcon={<PlusIcon width={14} />}
          >
            Add Phone
          </GKButton>
          <GKButton
            fullWidth
            variant="contained"
            onClick={() => setOpen(false)}
          >
            Save
          </GKButton>
        </Grid2>
      }
    >
      <Grid2 container spacing={3} pb={1}>
        <Grid2 size={12}>
          <GKTextField
            placeholder="Search"
            size="small"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            slotProps={{
              input: {
                startAdornment: (
                  <SearchIcon width={22} color={theme.palette.grey[500]} />
                ),
                endAdornment: searchQuery && (
                  <IconButton onClick={() => setSearchQuery("")}>
                    <ClearIcon />
                  </IconButton>
                ),
              },
            }}
          />
        </Grid2>

        <Grid2 size={12}>
          {filteredFields.map((row) => {
            const originalIndex = fields.findIndex(
              (field) => field.id === row.id,
            );

            return (
              <Grid2
                container
                size={12}
                key={row.id}
                mt={"6px"}
                display={"flex"}
                alignItems={"center"}
              >
                <Grid2 size={11}>
                  <Controller
                    name={`couponUsage.${originalIndex}.phone`}
                    control={form.control}
                    render={({ field }) => (
                      <GKTextField
                        {...field}
                        size="small"
                        type="number"
                        placeholder="Phone No."
                      />
                    )}
                  />
                </Grid2>
                <Grid2 size={1}>
                  <IconButton
                    color="error"
                    onClick={() => remove(originalIndex)}
                  >
                    <DeleteIcon />
                  </IconButton>
                </Grid2>
              </Grid2>
            );
          })}
        </Grid2>
      </Grid2>
    </GKModal>
  );
};

export default PhoneNumberModal;
